import { Component, Input, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SafeResourceUrl } from '@angular/platform-browser';
import 'prismjs';
import 'prismjs/components/prism-sql';
import 'prismjs/components/prism-python';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-json';
import 'prismjs/themes/prism-okaidia.css';
import { Subject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FileData } from '../../../models/database';

declare var Prism: any
@Component({
  selector: 'app-file-view-component',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './file-view-component.component.html',
  styleUrl: './file-view-component.component.scss'
})
export class FileViewComponentComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() fileUrl!: SafeResourceUrl;
  @Input() file: File | undefined;
  fileContent: string | null = null;
  language: string = 'none';
  usePrism: boolean = false;
  csvHeaders: any;
  csvData: any;
  private destroy$ = new Subject<void>();

  constructor(
    private activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    if (this.file) {
      this.readFile(this.file);
    }
  }
  readFile(file: File) {
    const reader = new FileReader();

    reader.onload = (e: any) => {
      this.fileContent = e.target.result as string;
      const fileExtension = file.name.split('.').pop()?.toLowerCase();

      switch (fileExtension) {
       case 'sql':
        this.language = 'sql';
        break;
      case 'txt':
        this.language = 'txt';
        break;
      case 'csv':
        this.language = 'csv';
        break;
      }

      this.usePrism = true;
      setTimeout(() => {
        if (Prism) {
          Prism.highlightAll();
        } else {
          console.error("Prism is not loaded!");
        }
      }, 0);
    };

    reader.onerror = (error) => {
      console.error('Error reading file:', error);
      this.fileContent = "Error reading file.";
    };

    reader.readAsText(file);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onCancel() {
    this.activeModal.close();
  }


}
